import { isoString, systemClock, type Clock } from "../time.js";
import type { Label, LabelPatch } from "./types.js";

/** Apply a patch and bump updated_at. Immutable: returns a new object. */
export function updateLabel(label: Label, patch: LabelPatch, now: Clock = systemClock): Label {
  return {
    ...label,
    ...patch,
    id: label.id,
    created_at: label.created_at,
    updated_at: isoString(now()),
  };
}

/** Soft-delete: sets deleted_at without removing the row. */
export function softDeleteLabel(label: Label, now: Clock = systemClock): Label {
  const ts = isoString(now());
  return { ...label, deleted_at: ts, updated_at: ts };
}
